import { TextField } from "@material-ui/core";
import MaterialIcon from "material-icons-react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
// import NumberFormat from "react-number-format";
import Drawer from "../../../../../components/Drawer";
import xIconBlack from "../../../../../assets/img/x-icon-black.svg";
import SelectHoursFood from "./SelectHoursFood";
import api from "../../../../../config/api";
import { useAuth } from "../../../../../context/ContextApi";
import TextPhoneMask from "../../../../../components/Mask/TextPhoneMask";
import swal from "sweetalert";

const NewReserveFoodDrawer = ({
  isAddNewFoodDrawerOpen,
  reserveInitialFood,
  handleNewReserve,
  openDrawer,
  setShowProduct,
  showProduct,
  setOpenDrawer,
  isFashionDrawerOpen,
  loadBtn,
  product,
  showExtras,
  initialReserve,
  reserve,
  setAddNew,
  createFoodReservation,
  setReserve,
}) => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const { userEstablishment } = useAuth();
  const [error, setError] = useState(false);
  const [errorService, setErrorService] = useState(false);

  useEffect(() => {}, []);

  const validation = (e) => {
    e.preventDefault();
    let error = false;
    if (!reserve.client || !reserve.date || !reserve.hour || !reserve.tel || !reserve.email || !reserve.qtyClients) {
      error = true;
      setError(true);
      return swal("Campo não preenchido", "Verifique os dados enviados", "error");
    } else {
      error = false;
      setError(false);
    }

    if (!error) {
      createFoodReservation().then(() => {
        clear();
        setError(false);
        swal("Sucesso!", "Reserva efetuada com sucesso", "success");
      });
    }
  };

  const handlePhoneChange = async (event) => {
    if (!event.target.value) return;
    const phoneValue = event.target.value.replace(/\s/g, "");
    const response = await api.get(`/dashboard-verify-user/?phone=${phoneValue}`);
    if (response.data.user) {
      setName(() => response.data.user.name);
      setUserId(() => response.data.user._id);
      setEmail(() => response.data.user.email);
    } else {
      setName(() => "");
      setEmail(() => "");
      setUserId(() => "");
    }
  };

  const save = () => {
    reserve.client = name;
    reserve.email = email;
    reserve.userId = userId;
  };

  const clear = () => {
    setName("");
    setEmail("");
    setReserve(reserveInitialFood);
  };

  return (
    <Drawer
      show={isAddNewFoodDrawerOpen}
      onClose={() => {
        setAddNew(false);
        setOpenDrawer(false);
        clear();
      }}
    >
      <form style={{ maxHeight: "100%" }}>
        <div className="d-flex col align-items-center">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 me-auto">Adicionar Reserva</span>
        </div>
        <div className="d-flex flex-column">
          <TextField
            required
            label={"Telefone"}
            variant={"outlined"}
            name={"tel"}
            error={error}
            InputProps={{
              inputComponent: TextPhoneMask,
            }}
            onChange={(e) => {
              handleNewReserve(e);
              handlePhoneChange(e);
            }}
            onBlur={() => save()}
            value={reserve?.tel}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <TextField
            error={error}
            required
            label={"Cliente"}
            variant={"outlined"}
            name={"client"}
            onChange={(e) => {
              handleNewReserve(e);
              setName(e.target.value);
            }}
            value={name}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <TextField
            required
            error={error}
            label={"E-mail"}
            variant={"outlined"}
            type={"email"}
            name={"email"}
            onChange={(e) => {
              handleNewReserve(e);
              setEmail(e.target.value);
            }}
            value={email}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />

          <TextField
            error={error}
            required
            label={"Data"}
            variant={"outlined"}
            value={reserve?.date}
            name={"date"}
            type={"date"}
            onChange={(e) => {
              handleNewReserve(e);
              // setEmail(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <SelectHoursFood error={error} date={reserve?.date} handleNewReserve={handleNewReserve} />
          <TextField
            error={error}
            required
            label={"Número de pessoas"}
            variant={"outlined"}
            type="number"
            name="qtyClients"
            value={reserve?.qtyClients}
            onChange={(e) => {
              handleNewReserve(e);
              // setEmail(e.target.value);
            }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <TextField
            label={"Observação geral"}
            variant={"outlined"}
            value={reserve?.description}
            onChange={(e) => {
              handleNewReserve(e);
              // setEmail(e.target.value);
            }}
            name={"description"}
            multiline
            minRows={4}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
        </div>
        <div className={`col-12 col-lg d-flex justify-content-end mt-5 mb-3`}>
          <button
            onClick={(e) => setOpenDrawer(false)}
            className="bg-transparent border-1 me-4 rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 botton-cancel"
          >
            Cancelar
          </button>

          {loadBtn ? (
            <div className="btn br-6 bg-gradient-theme-blue text-white px-4 d-flex align-items-center justify-content-center">
              <Spinner animation="border" role="status" style={{ height: 20, width: 20 }} className="mx-2" />
            </div>
          ) : (
            <button
              disabled={loadBtn}
              onClick={(e) => validation(e)}
              className="btn br-6 bg-gradient-theme-blue text-white px-4"
            >
              Salvar
            </button>
          )}
        </div>
      </form>
    </Drawer>
  );
};

export default NewReserveFoodDrawer;
